module.exports = __webpack_public_path__ + "img/bookmark-03.fd4212fc.svg";